const exportCSV = data => {
  //
  var tableHeaders = data[0];

  var dataTable = new Array();
  dataTable.push(tableHeaders);

  //now looping around the data
  data.forEach(function(row, index) {
    if (index !== 0) dataTable.push(row);
  });
  // console.log(dataTable.length);

  let csvContent = ""; //"data:text/csv;charset=utf-8,";
  // var i = 0;
  dataTable.forEach(function(rowArray) {
    let row = rowArray.join(",");
    csvContent += row + "\r\n";
    // i++;
  });
  // console.log('i=' + i);
  //calling the csv download via anchor tag(link) so we can provide a name for the file
  var encodedUri =
    "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);
  var link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.style.display = "none";
  link.setAttribute(
    "download",
    "mayai_details_" +
      (new Date().getMonth() + 1) +
      "_" +
      new Date().getFullYear() +
      ".csv"
  ); //change it to give your own name
  link.innerHTML = "Export";
  document.body.appendChild(link); // Required for FF

  link.click();
  link.remove(); //removing the link after the download
};
export { exportCSV };
